module.exports = __webpack_public_path__ + "static/media/imgedit_277.324eb351.ico";